import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';

@Component({
  selector: 'app-syndata',
  templateUrl: './syndata.component.html',
  styleUrls: ['./syndata.component.css']
})
export class SyndataComponent implements OnInit {

  constructor(private http: HttpClient, private System: TSFuntionService) { }

  ngOnInit() {
    this.SynData("Get_BANKKEY");
    this.SynData("Get_BUSINESS_PLACE");
    this.SynData("Get_COST_CENTER");
    this.SynData("Get_IO");
    this.SynData("Get_GL_ACCOUNT");
    this.SynData("Get_PAYMENT_TERM");
    this.SynData("Get_VENDOR");
    this.SynData("Get_VENDOR_BANK");
    this.SynData("Get_CUSTOMER");
  }

  SynData(Fn) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    this.http.get<any>(this.System.SiteName + "api/SynData/" + encodeURIComponent(String(Fn)), httpOptions).subscribe(res => {});
  }
}
